/**
 * @author gll
 * 功能：品牌模块
 */
import { Service } from '@/tools'

export class BrandService<T extends TCommodity.Brand> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TCommodity.Brand}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  //查询品牌列表
  // /api/commodity/brand/v1/queryPageList
  queryPageList = <K extends T['ApiQueryPageList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiQueryPageList', data)

  //新增品牌
  // /api/commodity/brand/v1/addBrand
  addBrand = <K extends T['ApiAddBrand']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAddBrand', data, '创建成功')

  //查询品牌详情
  // /api/commodity/brand/v1/queryBrandDetails
  queryBrandDetails = <K extends T['ApiQueryBrandDetails']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiQueryBrandDetails', data)

  //更新品牌
  // /api/commodity/brand/v1/updateBrand
  updateBrand = <K extends T['ApiUpdateBrand']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateBrand', data, '更新成功')

  //禁用品牌
  // /api/commodity/brand/v1/forbiddenBrand
  forbiddenBrand = <K extends T['ApiForbiddenBrand']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiForbiddenBrand', data)

  //启用品牌
  // /api/commodity/brand/v1/enableBrand
  enableBrand = <K extends T['ApiEnableBrand']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiEnableBrand', data)

  //删除品牌
  // /api/commodity/brand/v1/deleteBrand
  deleteBrand = <K extends T['ApiDeleteBrand']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDeleteBrand', data, '删除成功')
}
